var _asyncToGenerator = require("/home/runner/work/awarego-my/awarego-my/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/home/runner/work/awarego-my/awarego-my/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/home/runner/work/awarego-my/awarego-my/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _createClass = require("/home/runner/work/awarego-my/awarego-my/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/home/runner/work/awarego-my/awarego-my/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).Cmi5 = t();
}(this, function () {
  "use strict";

  "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
  var e = {
    exports: {}
  };
  !function (e, t) {
    e.exports = function () {
      var e, t;
      !function (e) {
        e.SIGNATURE = "http://adlnet.gov/expapi/attachments/signature", e.CERTIFICATE_OF_COMPLETION = "http://id.tincanapi.com/attachment/certificate-of-completion", e.CONTRACT = "http://id.tincanapi.com/attachment/contract", e.SUPPORTING_MEDIA = "http://id.tincanapi.com/attachment/supporting_media";
      }(e || (e = {})), function (e) {
        e.ABOUT = "about", e.AGENTS = "agents", e.ACTIVITIES = "activities", e.ACTIVITY_PROFILE = "activities/profile", e.STATE = "activities/state", e.AGENT_PROFILE = "agents/profile", e.STATEMENT = "statements";
      }(t || (t = {}));

      var n = /*#__PURE__*/_createClass(function n() {
        _classCallCheck(this, n);
      });

      n.INITIALIZED = {
        id: "http://adlnet.gov/expapi/verbs/initialized",
        display: {
          "en-US": "initialized"
        }
      }, n.TERMINATED = {
        id: "http://adlnet.gov/expapi/verbs/terminated",
        display: {
          "en-US": "terminated"
        }
      }, n.SUSPENDED = {
        id: "http://adlnet.gov/expapi/verbs/suspended",
        display: {
          "en-US": "suspended"
        }
      }, n.RESUMED = {
        id: "http://adlnet.gov/expapi/verbs/resumed",
        display: {
          "en-US": "resumed"
        }
      }, n.PASSED = {
        id: "http://adlnet.gov/expapi/verbs/passed",
        display: {
          "en-US": "passed"
        }
      }, n.FAILED = {
        id: "http://adlnet.gov/expapi/verbs/failed",
        display: {
          "en-US": "failed"
        }
      }, n.SCORED = {
        id: "http://adlnet.gov/expapi/verbs/scored",
        display: {
          "en-US": "scored"
        }
      }, n.COMPLETED = {
        id: "http://adlnet.gov/expapi/verbs/completed",
        display: {
          "en-US": "completed"
        }
      }, n.RESPONDED = {
        id: "http://adlnet.gov/expapi/verbs/responded",
        display: {
          "en-US": "responded"
        }
      }, n.COMMENTED = {
        id: "http://adlnet.gov/expapi/verbs/commented",
        display: {
          "en-US": "commented"
        }
      }, n.VOIDED = {
        id: "http://adlnet.gov/expapi/verbs/voided",
        display: {
          "en-US": "voided"
        }
      }, n.PROGRESSED = {
        id: "http://adlnet.gov/expapi/verbs/progressed",
        display: {
          "en-US": "progressed"
        }
      }, n.ANSWERED = {
        id: "http://adlnet.gov/expapi/verbs/answered",
        display: {
          "en-US": "answered"
        }
      };
      var r = "\r\n";

      function o(e, t) {
        var n = [],
            o = (Math.random() + " ").substring(2, 10) + (Math.random() + " ").substring(2, 10),
            i = {
          "Content-Type": "multipart/mixed; boundary=" + o
        };
        n.push(function (e, t) {
          return ["--" + t, "Content-Type: application/json", 'Content-Disposition: form-data; name="statement"', "", JSON.stringify(e)].join(r) + r;
        }(e, o));
        var a = Array.isArray(e) ? e.reduce(function (e, t) {
          return e.concat(t.attachments);
        }, []) : e.attachments;
        return t.forEach(function (e, t) {
          var i = a[t];
          n.push(function (e, t) {
            return ["--" + t, "Content-Type: " + e.contentType, "Content-Transfer-Encoding: binary", "X-Experience-API-Hash: " + e.sha2].join(r) + r + r;
          }(i, o)), n.push(e);
        }), n.push("\r\n--".concat(o, "--\r\n")), {
          header: i,
          blob: new Blob(n)
        };
      }

      function i(e) {
        var t = {},
            n = e.split("?")[1] || null;
        return n ? (new URLSearchParams(n).forEach(function (e, n) {
          try {
            t[n] = JSON.parse(e);
          } catch (_unused) {
            t[n] = e;
          }

          var r;
          "actor" === n && (t.actor = (r = t.actor, ["name", "mbox", "account"].forEach(function (e) {
            if (Array.isArray(r[e])) switch (e) {
              case "account":
                r[e] = _objectSpread(_objectSpread({}, r.account[0].accountServiceHomePage ? {
                  homePage: r.account[0].accountServiceHomePage
                } : null), r.account[0].accountName ? {
                  name: r.account[0].accountName
                } : null);
                break;

              default:
                r[e] = r[e][0];
            }
          }), r));
        }), t) : t;
      }

      var a = 3600;

      var s = {
        exports: {}
      },
          c = function c(e, t) {
        return function () {
          for (var n = new Array(arguments.length), r = 0; r < n.length; r++) {
            n[r] = arguments[r];
          }

          return e.apply(t, n);
        };
      },
          u = c,
          f = Object.prototype.toString;

      function l(e) {
        return "[object Array]" === f.call(e);
      }

      function d(e) {
        return void 0 === e;
      }

      function p(e) {
        return null !== e && "object" == typeof e;
      }

      function h(e) {
        if ("[object Object]" !== f.call(e)) return !1;
        var t = Object.getPrototypeOf(e);
        return null === t || t === Object.prototype;
      }

      function m(e) {
        return "[object Function]" === f.call(e);
      }

      function g(e, t) {
        if (null != e) if ("object" != typeof e && (e = [e]), l(e)) for (var n = 0, r = e.length; n < r; n++) {
          t.call(null, e[n], n, e);
        } else for (var o in e) {
          Object.prototype.hasOwnProperty.call(e, o) && t.call(null, e[o], o, e);
        }
      }

      var y = {
        isArray: l,
        isArrayBuffer: function isArrayBuffer(e) {
          return "[object ArrayBuffer]" === f.call(e);
        },
        isBuffer: function isBuffer(e) {
          return null !== e && !d(e) && null !== e.constructor && !d(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
        },
        isFormData: function isFormData(e) {
          return "undefined" != typeof FormData && e instanceof FormData;
        },
        isArrayBufferView: function isArrayBufferView(e) {
          return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer;
        },
        isString: function isString(e) {
          return "string" == typeof e;
        },
        isNumber: function isNumber(e) {
          return "number" == typeof e;
        },
        isObject: p,
        isPlainObject: h,
        isUndefined: d,
        isDate: function isDate(e) {
          return "[object Date]" === f.call(e);
        },
        isFile: function isFile(e) {
          return "[object File]" === f.call(e);
        },
        isBlob: function isBlob(e) {
          return "[object Blob]" === f.call(e);
        },
        isFunction: m,
        isStream: function isStream(e) {
          return p(e) && m(e.pipe);
        },
        isURLSearchParams: function isURLSearchParams(e) {
          return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams;
        },
        isStandardBrowserEnv: function isStandardBrowserEnv() {
          return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
        },
        forEach: g,
        merge: function e() {
          var t = {};

          function n(n, r) {
            h(t[r]) && h(n) ? t[r] = e(t[r], n) : h(n) ? t[r] = e({}, n) : l(n) ? t[r] = n.slice() : t[r] = n;
          }

          for (var r = 0, o = arguments.length; r < o; r++) {
            g(arguments[r], n);
          }

          return t;
        },
        extend: function extend(e, t, n) {
          return g(t, function (t, r) {
            e[r] = n && "function" == typeof t ? u(t, n) : t;
          }), e;
        },
        trim: function trim(e) {
          return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
        },
        stripBOM: function stripBOM(e) {
          return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e;
        }
      },
          v = y;

      function b(e) {
        return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
      }

      var E = function E(e, t, n) {
        if (!t) return e;
        var r;
        if (n) r = n(t);else if (v.isURLSearchParams(t)) r = t.toString();else {
          var o = [];
          v.forEach(t, function (e, t) {
            null != e && (v.isArray(e) ? t += "[]" : e = [e], v.forEach(e, function (e) {
              v.isDate(e) ? e = e.toISOString() : v.isObject(e) && (e = JSON.stringify(e)), o.push(b(t) + "=" + b(e));
            }));
          }), r = o.join("&");
        }

        if (r) {
          var i = e.indexOf("#");
          -1 !== i && (e = e.slice(0, i)), e += (-1 === e.indexOf("?") ? "?" : "&") + r;
        }

        return e;
      },
          S = y;

      function w() {
        this.handlers = [];
      }

      w.prototype.use = function (e, t, n) {
        return this.handlers.push({
          fulfilled: e,
          rejected: t,
          synchronous: !!n && n.synchronous,
          runWhen: n ? n.runWhen : null
        }), this.handlers.length - 1;
      }, w.prototype.eject = function (e) {
        this.handlers[e] && (this.handlers[e] = null);
      }, w.prototype.forEach = function (e) {
        S.forEach(this.handlers, function (t) {
          null !== t && e(t);
        });
      };

      var T = w,
          A = y,
          O = function O(e, t, n, r, o) {
        return e.config = t, n && (e.code = n), e.request = r, e.response = o, e.isAxiosError = !0, e.toJSON = function () {
          return {
            message: this.message,
            name: this.name,
            description: this.description,
            number: this.number,
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
          };
        }, e;
      },
          P = O,
          x = function x(e, t, n, r, o) {
        var i = new Error(e);
        return P(i, t, n, r, o);
      },
          R = x,
          j = y,
          I = j.isStandardBrowserEnv() ? {
        write: function write(e, t, n, r, o, i) {
          var a = [];
          a.push(e + "=" + encodeURIComponent(t)), j.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), j.isString(r) && a.push("path=" + r), j.isString(o) && a.push("domain=" + o), !0 === i && a.push("secure"), document.cookie = a.join("; ");
        },
        read: function read(e) {
          var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
          return t ? decodeURIComponent(t[3]) : null;
        },
        remove: function remove(e) {
          this.write(e, "", Date.now() - 864e5);
        }
      } : {
        write: function write() {},
        read: function read() {
          return null;
        },
        remove: function remove() {}
      },
          N = function N(e) {
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
      },
          C = function C(e, t) {
        return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
      },
          D = y,
          L = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"],
          U = y,
          M = U.isStandardBrowserEnv() ? function () {
        var e,
            t = /(msie|trident)/i.test(navigator.userAgent),
            n = document.createElement("a");

        function r(e) {
          var r = e;
          return t && (n.setAttribute("href", r), r = n.href), n.setAttribute("href", r), {
            href: n.href,
            protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
            host: n.host,
            search: n.search ? n.search.replace(/^\?/, "") : "",
            hash: n.hash ? n.hash.replace(/^#/, "") : "",
            hostname: n.hostname,
            port: n.port,
            pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
          };
        }

        return e = r(window.location.href), function (t) {
          var n = U.isString(t) ? r(t) : t;
          return n.protocol === e.protocol && n.host === e.host;
        };
      }() : function () {
        return !0;
      };

      function q(e) {
        this.message = e;
      }

      q.prototype.toString = function () {
        return "Cancel" + (this.message ? ": " + this.message : "");
      }, q.prototype.__CANCEL__ = !0;

      var _ = q,
          B = y,
          k = function k(e, t, n) {
        var r = n.config.validateStatus;
        n.status && r && !r(n.status) ? t(R("Request failed with status code " + n.status, n.config, null, n.request, n)) : e(n);
      },
          F = I,
          V = E,
          $ = function $(e, t) {
        return e && !N(t) ? C(e, t) : t;
      },
          J = function J(e) {
        var t,
            n,
            r,
            o = {};
        return e ? (D.forEach(e.split("\n"), function (e) {
          if (r = e.indexOf(":"), t = D.trim(e.substr(0, r)).toLowerCase(), n = D.trim(e.substr(r + 1)), t) {
            if (o[t] && L.indexOf(t) >= 0) return;
            o[t] = "set-cookie" === t ? (o[t] ? o[t] : []).concat([n]) : o[t] ? o[t] + ", " + n : n;
          }
        }), o) : o;
      },
          H = M,
          z = x,
          G = re,
          X = _,
          W = function W(e) {
        return new Promise(function (t, n) {
          var r,
              o = e.data,
              i = e.headers,
              a = e.responseType;

          function s() {
            e.cancelToken && e.cancelToken.unsubscribe(r), e.signal && e.signal.removeEventListener("abort", r);
          }

          B.isFormData(o) && delete i["Content-Type"];
          var c = new XMLHttpRequest();

          if (e.auth) {
            var u = e.auth.username || "",
                f = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
            i.Authorization = "Basic " + btoa(u + ":" + f);
          }

          var l = $(e.baseURL, e.url);

          function d() {
            if (c) {
              var r = "getAllResponseHeaders" in c ? J(c.getAllResponseHeaders()) : null,
                  o = {
                data: a && "text" !== a && "json" !== a ? c.response : c.responseText,
                status: c.status,
                statusText: c.statusText,
                headers: r,
                config: e,
                request: c
              };
              k(function (e) {
                t(e), s();
              }, function (e) {
                n(e), s();
              }, o), c = null;
            }
          }

          if (c.open(e.method.toUpperCase(), V(l, e.params, e.paramsSerializer), !0), c.timeout = e.timeout, "onloadend" in c ? c.onloadend = d : c.onreadystatechange = function () {
            c && 4 === c.readyState && (0 !== c.status || c.responseURL && 0 === c.responseURL.indexOf("file:")) && setTimeout(d);
          }, c.onabort = function () {
            c && (n(z("Request aborted", e, "ECONNABORTED", c)), c = null);
          }, c.onerror = function () {
            n(z("Network Error", e, null, c)), c = null;
          }, c.ontimeout = function () {
            var t = "timeout of " + e.timeout + "ms exceeded",
                r = e.transitional || G.transitional;
            e.timeoutErrorMessage && (t = e.timeoutErrorMessage), n(z(t, e, r.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", c)), c = null;
          }, B.isStandardBrowserEnv()) {
            var p = (e.withCredentials || H(l)) && e.xsrfCookieName ? F.read(e.xsrfCookieName) : void 0;
            p && (i[e.xsrfHeaderName] = p);
          }

          "setRequestHeader" in c && B.forEach(i, function (e, t) {
            void 0 === o && "content-type" === t.toLowerCase() ? delete i[t] : c.setRequestHeader(t, e);
          }), B.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), a && "json" !== a && (c.responseType = e.responseType), "function" == typeof e.onDownloadProgress && c.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && c.upload && c.upload.addEventListener("progress", e.onUploadProgress), (e.cancelToken || e.signal) && (r = function r(e) {
            c && (n(!e || e && e.type ? new X("canceled") : e), c.abort(), c = null);
          }, e.cancelToken && e.cancelToken.subscribe(r), e.signal && (e.signal.aborted ? r() : e.signal.addEventListener("abort", r))), o || (o = null), c.send(o);
        });
      },
          Y = y,
          K = function K(e, t) {
        A.forEach(e, function (n, r) {
          r !== t && r.toUpperCase() === t.toUpperCase() && (e[t] = n, delete e[r]);
        });
      },
          Z = O,
          Q = {
        "Content-Type": "application/x-www-form-urlencoded"
      };

      function ee(e, t) {
        !Y.isUndefined(e) && Y.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
      }

      var te,
          ne = {
        transitional: {
          silentJSONParsing: !0,
          forcedJSONParsing: !0,
          clarifyTimeoutError: !1
        },
        adapter: (("undefined" != typeof XMLHttpRequest || "undefined" != typeof process && "[object process]" === Object.prototype.toString.call(process)) && (te = W), te),
        transformRequest: [function (e, t) {
          return K(t, "Accept"), K(t, "Content-Type"), Y.isFormData(e) || Y.isArrayBuffer(e) || Y.isBuffer(e) || Y.isStream(e) || Y.isFile(e) || Y.isBlob(e) ? e : Y.isArrayBufferView(e) ? e.buffer : Y.isURLSearchParams(e) ? (ee(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : Y.isObject(e) || t && "application/json" === t["Content-Type"] ? (ee(t, "application/json"), function (e, t, n) {
            if (Y.isString(e)) try {
              return (t || JSON.parse)(e), Y.trim(e);
            } catch (e) {
              if ("SyntaxError" !== e.name) throw e;
            }
            return (n || JSON.stringify)(e);
          }(e)) : e;
        }],
        transformResponse: [function (e) {
          var t = this.transitional || ne.transitional,
              n = t && t.silentJSONParsing,
              r = t && t.forcedJSONParsing,
              o = !n && "json" === this.responseType;
          if (o || r && Y.isString(e) && e.length) try {
            return JSON.parse(e);
          } catch (e) {
            if (o) {
              if ("SyntaxError" === e.name) throw Z(e, this, "E_JSON_PARSE");
              throw e;
            }
          }
          return e;
        }],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        maxBodyLength: -1,
        validateStatus: function validateStatus(e) {
          return e >= 200 && e < 300;
        },
        headers: {
          common: {
            Accept: "application/json, text/plain, */*"
          }
        }
      };
      Y.forEach(["delete", "get", "head"], function (e) {
        ne.headers[e] = {};
      }), Y.forEach(["post", "put", "patch"], function (e) {
        ne.headers[e] = Y.merge(Q);
      });

      var re = ne,
          oe = y,
          ie = re,
          ae = function ae(e) {
        return !(!e || !e.__CANCEL__);
      },
          se = y,
          ce = function ce(e, t, n) {
        var r = this || ie;
        return oe.forEach(n, function (n) {
          e = n.call(r, e, t);
        }), e;
      },
          ue = ae,
          fe = re,
          le = _;

      function de(e) {
        if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new le("canceled");
      }

      var pe = y,
          he = function he(e, t) {
        t = t || {};
        var n = {};

        function r(e, t) {
          return pe.isPlainObject(e) && pe.isPlainObject(t) ? pe.merge(e, t) : pe.isPlainObject(t) ? pe.merge({}, t) : pe.isArray(t) ? t.slice() : t;
        }

        function o(n) {
          return pe.isUndefined(t[n]) ? pe.isUndefined(e[n]) ? void 0 : r(void 0, e[n]) : r(e[n], t[n]);
        }

        function i(e) {
          if (!pe.isUndefined(t[e])) return r(void 0, t[e]);
        }

        function a(n) {
          return pe.isUndefined(t[n]) ? pe.isUndefined(e[n]) ? void 0 : r(void 0, e[n]) : r(void 0, t[n]);
        }

        function s(n) {
          return n in t ? r(e[n], t[n]) : n in e ? r(void 0, e[n]) : void 0;
        }

        var c = {
          url: i,
          method: i,
          data: i,
          baseURL: a,
          transformRequest: a,
          transformResponse: a,
          paramsSerializer: a,
          timeout: a,
          timeoutMessage: a,
          withCredentials: a,
          adapter: a,
          responseType: a,
          xsrfCookieName: a,
          xsrfHeaderName: a,
          onUploadProgress: a,
          onDownloadProgress: a,
          decompress: a,
          maxContentLength: a,
          maxBodyLength: a,
          transport: a,
          httpAgent: a,
          httpsAgent: a,
          cancelToken: a,
          socketPath: a,
          responseEncoding: a,
          validateStatus: s
        };
        return pe.forEach(Object.keys(e).concat(Object.keys(t)), function (e) {
          var t = c[e] || o,
              r = t(e);
          pe.isUndefined(r) && t !== s || (n[e] = r);
        }), n;
      },
          me = "0.22.0",
          ge = me,
          ye = {};

      ["object", "boolean", "number", "function", "string", "symbol"].forEach(function (e, t) {
        ye[e] = function (n) {
          return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
        };
      });
      var ve = {};

      ye.transitional = function (e, t, n) {
        function r(e, t) {
          return "[Axios v" + ge + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
        }

        return function (n, o, i) {
          if (!1 === e) throw new Error(r(o, " has been removed" + (t ? " in " + t : "")));
          return t && !ve[o] && (ve[o] = !0, console.warn(r(o, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, o, i);
        };
      };

      var be = y,
          Ee = E,
          Se = T,
          we = function we(e) {
        return de(e), e.headers = e.headers || {}, e.data = ce.call(e, e.data, e.headers, e.transformRequest), e.headers = se.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), se.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
          delete e.headers[t];
        }), (e.adapter || fe.adapter)(e).then(function (t) {
          return de(e), t.data = ce.call(e, t.data, t.headers, e.transformResponse), t;
        }, function (t) {
          return ue(t) || (de(e), t && t.response && (t.response.data = ce.call(e, t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t);
        });
      },
          Te = he,
          Ae = {
        assertOptions: function assertOptions(e, t, n) {
          if ("object" != typeof e) throw new TypeError("options must be an object");

          for (var r = Object.keys(e), o = r.length; o-- > 0;) {
            var i = r[o],
                a = t[i];

            if (a) {
              var s = e[i],
                  c = void 0 === s || a(s, i, e);
              if (!0 !== c) throw new TypeError("option " + i + " must be " + c);
            } else if (!0 !== n) throw Error("Unknown option " + i);
          }
        },
        validators: ye
      },
          Oe = Ae.validators;

      function Pe(e) {
        this.defaults = e, this.interceptors = {
          request: new Se(),
          response: new Se()
        };
      }

      Pe.prototype.request = function (e) {
        "string" == typeof e ? (e = arguments[1] || {}).url = arguments[0] : e = e || {}, (e = Te(this.defaults, e)).method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
        var t = e.transitional;
        void 0 !== t && Ae.assertOptions(t, {
          silentJSONParsing: Oe.transitional(Oe.boolean),
          forcedJSONParsing: Oe.transitional(Oe.boolean),
          clarifyTimeoutError: Oe.transitional(Oe.boolean)
        }, !1);
        var n = [],
            r = !0;
        this.interceptors.request.forEach(function (t) {
          "function" == typeof t.runWhen && !1 === t.runWhen(e) || (r = r && t.synchronous, n.unshift(t.fulfilled, t.rejected));
        });
        var o,
            i = [];

        if (this.interceptors.response.forEach(function (e) {
          i.push(e.fulfilled, e.rejected);
        }), !r) {
          var a = [we, void 0];

          for (Array.prototype.unshift.apply(a, n), a = a.concat(i), o = Promise.resolve(e); a.length;) {
            o = o.then(a.shift(), a.shift());
          }

          return o;
        }

        for (var s = e; n.length;) {
          var c = n.shift(),
              u = n.shift();

          try {
            s = c(s);
          } catch (e) {
            u(e);
            break;
          }
        }

        try {
          o = we(s);
        } catch (e) {
          return Promise.reject(e);
        }

        for (; i.length;) {
          o = o.then(i.shift(), i.shift());
        }

        return o;
      }, Pe.prototype.getUri = function (e) {
        return e = Te(this.defaults, e), Ee(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
      }, be.forEach(["delete", "get", "head", "options"], function (e) {
        Pe.prototype[e] = function (t, n) {
          return this.request(Te(n || {}, {
            method: e,
            url: t,
            data: (n || {}).data
          }));
        };
      }), be.forEach(["post", "put", "patch"], function (e) {
        Pe.prototype[e] = function (t, n, r) {
          return this.request(Te(r || {}, {
            method: e,
            url: t,
            data: n
          }));
        };
      });
      var xe = Pe,
          Re = _;

      function je(e) {
        if ("function" != typeof e) throw new TypeError("executor must be a function.");
        var t;
        this.promise = new Promise(function (e) {
          t = e;
        });
        var n = this;
        this.promise.then(function (e) {
          if (n._listeners) {
            var t,
                r = n._listeners.length;

            for (t = 0; t < r; t++) {
              n._listeners[t](e);
            }

            n._listeners = null;
          }
        }), this.promise.then = function (e) {
          var t,
              r = new Promise(function (e) {
            n.subscribe(e), t = e;
          }).then(e);
          return r.cancel = function () {
            n.unsubscribe(t);
          }, r;
        }, e(function (e) {
          n.reason || (n.reason = new Re(e), t(n.reason));
        });
      }

      je.prototype.throwIfRequested = function () {
        if (this.reason) throw this.reason;
      }, je.prototype.subscribe = function (e) {
        this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
      }, je.prototype.unsubscribe = function (e) {
        if (this._listeners) {
          var t = this._listeners.indexOf(e);

          -1 !== t && this._listeners.splice(t, 1);
        }
      }, je.source = function () {
        var e;
        return {
          token: new je(function (t) {
            e = t;
          }),
          cancel: e
        };
      };

      var Ie = je,
          Ne = y,
          Ce = c,
          De = xe,
          Le = he,
          Ue = function e(t) {
        var n = new De(t),
            r = Ce(De.prototype.request, n);
        return Ne.extend(r, De.prototype, n), Ne.extend(r, n), r.create = function (n) {
          return e(Le(t, n));
        }, r;
      }(re);

      Ue.Axios = De, Ue.Cancel = _, Ue.CancelToken = Ie, Ue.isCancel = ae, Ue.VERSION = me, Ue.all = function (e) {
        return Promise.all(e);
      }, Ue.spread = function (e) {
        return function (t) {
          return e.apply(null, t);
        };
      }, Ue.isAxiosError = function (e) {
        return "object" == typeof e && !0 === e.isAxiosError;
      }, s.exports = Ue, s.exports.default = Ue;
      var Me = s.exports;

      function qe(e, t) {
        var n = "".concat(e, ":").concat(t);
        if ("undefined" != typeof window && window.btoa) return "Basic " + btoa(n);
        if ("undefined" != typeof Buffer) return "Basic " + Buffer.from(n, "binary").toString("base64");
        throw new Error("Environment does not support base64 conversion.");
      }

      var _e = /*#__PURE__*/function () {
        function _e(e, t) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "1.0.3";

          _classCallCheck(this, _e);

          this.endpoint = function (e) {
            return e.endsWith("/") ? e : e + "/";
          }(e), this.headers = {
            "X-Experience-API-Version": n,
            "Content-Type": "application/json",
            Authorization: t || qe("", "")
          };
        }

        _createClass(_e, [{
          key: "getAbout",
          value: function getAbout() {
            return this.requestResource(t.ABOUT);
          }
        }, {
          key: "getAgent",
          value: function getAgent(e) {
            return this.requestResource(t.AGENTS, {
              agent: e
            });
          }
        }, {
          key: "getStatement",
          value: function getStatement(e) {
            return this.requestResource(t.STATEMENT, e);
          }
        }, {
          key: "getVoidedStatement",
          value: function getVoidedStatement(e) {
            return this.requestResource(t.STATEMENT, e);
          }
        }, {
          key: "getStatements",
          value: function getStatements(e) {
            return this.requestResource(t.STATEMENT, e);
          }
        }, {
          key: "getMoreStatements",
          value: function getMoreStatements(e) {
            var t = new URL(this.endpoint),
                n = "".concat(t.protocol, "//").concat(t.host).concat(e);
            return this.requestURL(n);
          }
        }, {
          key: "sendStatement",
          value: function sendStatement(e, n) {
            if (null == n ? void 0 : n.length) {
              var _r = o(e, n);

              return this.requestResource(t.STATEMENT, {}, {
                method: "POST",
                headers: _r.header,
                data: _r.blob
              });
            }

            return this.requestResource(t.STATEMENT, {}, {
              method: "POST",
              data: e
            });
          }
        }, {
          key: "sendStatements",
          value: function sendStatements(e, n) {
            if (null == n ? void 0 : n.length) {
              var _r2 = o(e, n);

              return this.requestResource(t.STATEMENT, {}, {
                method: "POST",
                headers: _r2.header,
                data: _r2.blob
              });
            }

            return this.requestResource(t.STATEMENT, {}, {
              method: "POST",
              data: e
            });
          }
        }, {
          key: "voidStatement",
          value: function voidStatement(e, t) {
            var r = {
              actor: e,
              verb: n.VOIDED,
              object: {
                objectType: "StatementRef",
                id: t
              }
            };
            return this.sendStatement(r);
          }
        }, {
          key: "voidStatements",
          value: function voidStatements(e, t) {
            var r = t.map(function (t) {
              return {
                actor: e,
                verb: n.VOIDED,
                object: {
                  objectType: "StatementRef",
                  id: t
                }
              };
            });
            return this.sendStatements(r);
          }
        }, {
          key: "createState",
          value: function createState(e, n, r, o, i, a, s) {
            var c = {};
            return a && (c[s] = a), this.requestResource(t.STATE, _objectSpread({
              agent: e,
              activityId: n,
              stateId: r
            }, i ? {
              registration: i
            } : {}), {
              method: "POST",
              data: o,
              headers: c
            });
          }
        }, {
          key: "setState",
          value: function setState(e, n, r, o, i, a, s, c) {
            var u = {};
            return a && (u[s] = a), c && (u["Content-Type"] = c), this.requestResource(t.STATE, _objectSpread({
              agent: e,
              activityId: n,
              stateId: r
            }, i ? {
              registration: i
            } : {}), {
              method: "PUT",
              data: o,
              headers: u
            });
          }
        }, {
          key: "getStates",
          value: function getStates(e, n, r, o) {
            return this.requestResource(t.STATE, _objectSpread(_objectSpread({
              agent: e,
              activityId: n
            }, r ? {
              registration: r
            } : {}), o ? {
              since: o
            } : {}));
          }
        }, {
          key: "getState",
          value: function getState(e, n, r, o) {
            return this.requestResource(t.STATE, _objectSpread({
              agent: e,
              activityId: n,
              stateId: r
            }, o ? {
              registration: o
            } : {}));
          }
        }, {
          key: "deleteState",
          value: function deleteState(e, n, r, o, i) {
            var a = {};
            return i && (a["If-Match"] = i), this.requestResource(t.STATE, _objectSpread({
              agent: e,
              activityId: n,
              stateId: r
            }, o ? {
              registration: o
            } : {}), {
              method: "DELETE",
              headers: a
            });
          }
        }, {
          key: "deleteStates",
          value: function deleteStates(e, n, r, o) {
            var i = {};
            return o && (i["If-Match"] = o), this.requestResource(t.STATE, _objectSpread({
              agent: e,
              activityId: n
            }, r ? {
              registration: r
            } : {}), {
              method: "DELETE",
              headers: i
            });
          }
        }, {
          key: "getActivity",
          value: function getActivity(e) {
            return this.requestResource(t.ACTIVITIES, {
              activityId: e
            });
          }
        }, {
          key: "createActivityProfile",
          value: function createActivityProfile(e, n, r, o, i) {
            var a = {};
            return o && (a[i] = o), this.requestResource(t.ACTIVITY_PROFILE, {
              activityId: e,
              profileId: n
            }, {
              method: "POST",
              data: r,
              headers: a
            });
          }
        }, {
          key: "setActivityProfile",
          value: function setActivityProfile(e, n, r, o, i, a) {
            var s = {};
            return s[i] = o, a && (s["Content-Type"] = a), this.requestResource(t.ACTIVITY_PROFILE, {
              activityId: e,
              profileId: n
            }, {
              method: "PUT",
              data: r,
              headers: s
            });
          }
        }, {
          key: "getActivityProfiles",
          value: function getActivityProfiles(e, n) {
            return this.requestResource(t.ACTIVITY_PROFILE, _objectSpread({
              activityId: e
            }, n ? {
              since: n
            } : {}));
          }
        }, {
          key: "getActivityProfile",
          value: function getActivityProfile(e, n) {
            return this.requestResource(t.ACTIVITY_PROFILE, {
              activityId: e,
              profileId: n
            });
          }
        }, {
          key: "deleteActivityProfile",
          value: function deleteActivityProfile(e, n, r) {
            var o = {};
            return r && (o["If-Match"] = r), this.requestResource(t.ACTIVITY_PROFILE, {
              activityId: e,
              profileId: n
            }, {
              method: "DELETE",
              headers: o
            });
          }
        }, {
          key: "createAgentProfile",
          value: function createAgentProfile(e, n, r, o, i) {
            var a = {};
            return o && (a[i] = o), this.requestResource(t.AGENT_PROFILE, {
              agent: e,
              profileId: n
            }, {
              method: "POST",
              data: r,
              headers: a
            });
          }
        }, {
          key: "setAgentProfile",
          value: function setAgentProfile(e, n, r, o, i, a) {
            var s = {};
            return s[i] = o, a && (s["Content-Type"] = a), this.requestResource(t.AGENT_PROFILE, {
              agent: e,
              profileId: n
            }, {
              method: "PUT",
              data: r,
              headers: s
            });
          }
        }, {
          key: "getAgentProfiles",
          value: function getAgentProfiles(e, n) {
            return this.requestResource(t.AGENT_PROFILE, _objectSpread({
              agent: e
            }, n ? {
              since: n
            } : {}));
          }
        }, {
          key: "getAgentProfile",
          value: function getAgentProfile(e, n) {
            return this.requestResource(t.AGENT_PROFILE, {
              agent: e,
              profileId: n
            });
          }
        }, {
          key: "deleteAgentProfile",
          value: function deleteAgentProfile(e, n, r) {
            var o = {};
            return r && (o["If-Match"] = r), this.requestResource(t.AGENT_PROFILE, {
              agent: e,
              profileId: n
            }, {
              method: "DELETE",
              headers: o
            });
          }
        }, {
          key: "requestResource",
          value: function requestResource(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var n = arguments.length > 2 ? arguments[2] : undefined;
            var r = this.generateURL(e, t);
            return this.requestURL(r, n);
          }
        }, {
          key: "requestURL",
          value: function requestURL(e, t) {
            return Me.request({
              method: (null == t ? void 0 : t.method) || "GET",
              url: e,
              headers: _objectSpread(_objectSpread({}, this.headers), null == t ? void 0 : t.headers),
              data: null == t ? void 0 : t.data
            }).then(function (e) {
              var t = e.headers["content-type"];
              return e.data && t && -1 !== t.indexOf("multipart/mixed") && (e.data = function (e) {
                var t = e.trim().split(r)[0].trim(),
                    n = e.split(t).map(function (e) {
                  return e.trim();
                }).filter(function (e) {
                  return "" !== e && "--" !== e;
                }),
                    o = [];

                for (var _e2 = 0; _e2 < n.length; _e2++) {
                  var _t = {},
                      _i = n[_e2].split(r);

                  for (var _e3 = 0; _e3 < _i.length - 2; _e3++) {
                    var _n = _i[_e3].split(":");

                    _t[_n[0]] = _n[1];
                  }

                  var _a = _i[_i.length - 1];
                  _t["Content-Type"].indexOf("application/json") > -1 && (_a = JSON.parse(_a)), o.push(_a);
                }

                return o;
              }(e.data)), e;
            });
          }
        }, {
          key: "generateURL",
          value: function generateURL(e, t) {
            var n = Object.keys(t).map(function (e) {
              var n = "agent" === e ? JSON.stringify(t[e]) : t[e];
              return n = encodeURIComponent(n), "".concat(e, "=").concat(n);
            }).join("&");
            return "".concat(this.endpoint).concat(e).concat(n ? "?" + n : "");
          }
        }]);

        return _e;
      }();

      return _e.default = _e, _e.AttachmentUsages = e, _e.Verbs = n, _e.calculateISO8601Duration = function (e, t) {
        var n = (t.getTime() - e.getTime()) / 1e3,
            r = Math.floor(n / 86400),
            o = n % 86400,
            i = Math.floor(o / a),
            s = o % a,
            c = Math.floor(s / 60),
            u = s % 60,
            f = Math.ceil(u);
        return "P".concat(r ? r + "D" : "", "T").concat(i ? i + "H" : "").concat(c ? c + "M" : "").concat(f ? f + "S" : "");
      }, _e.getSearchQueryParamsAsObject = i, _e.getXAPILaunchData = function () {
        if ("undefined" == typeof location) return Promise.reject(new Error("Environment does not support location.search"));
        var e = i(location.search);
        if (!e.xAPILaunchService) return Promise.reject(new Error("xAPILaunchService parameter not found in URL."));
        var t = new URL(e.xAPILaunchService);
        return t.pathname += "launch/" + e.xAPILaunchKey, Me({
          method: "POST",
          url: t.toString()
        }).then(function (e) {
          return e.data;
        });
      }, _e.getTinCanLaunchData = function () {
        if ("undefined" == typeof location) throw new Error("Environment does not support location.search");
        return i(location.search);
      }, _e.toBasicAuth = qe, _e;
    }();
  }(e);
  var t = e.exports;

  var n = /*#__PURE__*/_createClass(function n() {
    _classCallCheck(this, n);
  });

  n.MOVE_ON = {
    id: "https://w3id.org/xapi/cmi5/context/categories/moveon"
  }, n.CMI5 = {
    id: "https://w3id.org/xapi/cmi5/context/categories/cmi5"
  };

  var r = /*#__PURE__*/_createClass(function r() {
    _classCallCheck(this, r);
  });

  r.INITIALIZED = t.Verbs.INITIALIZED, r.COMPLETED = t.Verbs.COMPLETED, r.PASSED = t.Verbs.PASSED, r.FAILED = t.Verbs.FAILED, r.TERMINATED = t.Verbs.TERMINATED;

  var o = function o(e) {
    return function (e) {
      return !!e && "object" == typeof e;
    }(e) && !function (e) {
      var t = Object.prototype.toString.call(e);
      return "[object RegExp]" === t || "[object Date]" === t || function (e) {
        return e.$$typeof === i;
      }(e);
    }(e);
  };

  var i = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;

  function a(e, t) {
    return !1 !== t.clone && t.isMergeableObject(e) ? l((n = e, Array.isArray(n) ? [] : {}), e, t) : e;
    var n;
  }

  function s(e, t, n) {
    return e.concat(t).map(function (e) {
      return a(e, n);
    });
  }

  function c(e) {
    return Object.keys(e).concat(function (e) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function (t) {
        return e.propertyIsEnumerable(t);
      }) : [];
    }(e));
  }

  function u(e, t) {
    try {
      return t in e;
    } catch (e) {
      return !1;
    }
  }

  function f(e, t, n) {
    var r = {};
    return n.isMergeableObject(e) && c(e).forEach(function (t) {
      r[t] = a(e[t], n);
    }), c(t).forEach(function (o) {
      (function (e, t) {
        return u(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
      })(e, o) || (u(e, o) && n.isMergeableObject(t[o]) ? r[o] = function (e, t) {
        if (!t.customMerge) return l;
        var n = t.customMerge(e);
        return "function" == typeof n ? n : l;
      }(o, n)(e[o], t[o], n) : r[o] = a(t[o], n));
    }), r;
  }

  function l(e, t, n) {
    (n = n || {}).arrayMerge = n.arrayMerge || s, n.isMergeableObject = n.isMergeableObject || o, n.cloneUnlessOtherwiseSpecified = a;
    var r = Array.isArray(t);
    return r === Array.isArray(e) ? r ? n.arrayMerge(e, t, n) : f(e, t, n) : a(t, n);
  }

  l.all = function (e, t) {
    if (!Array.isArray(e)) throw new Error("first argument should be an array");
    return e.reduce(function (e, n) {
      return l(e, n, t);
    }, {});
  };

  var d = l,
      p = {
    exports: {}
  },
      h = function h(e, t) {
    return function () {
      for (var n = new Array(arguments.length), r = 0; r < n.length; r++) {
        n[r] = arguments[r];
      }

      return e.apply(t, n);
    };
  },
      m = h,
      g = Object.prototype.toString;

  function y(e) {
    return "[object Array]" === g.call(e);
  }

  function v(e) {
    return void 0 === e;
  }

  function b(e) {
    return null !== e && "object" == typeof e;
  }

  function E(e) {
    if ("[object Object]" !== g.call(e)) return !1;
    var t = Object.getPrototypeOf(e);
    return null === t || t === Object.prototype;
  }

  function S(e) {
    return "[object Function]" === g.call(e);
  }

  function w(e, t) {
    if (null != e) if ("object" != typeof e && (e = [e]), y(e)) for (var n = 0, r = e.length; n < r; n++) {
      t.call(null, e[n], n, e);
    } else for (var o in e) {
      Object.prototype.hasOwnProperty.call(e, o) && t.call(null, e[o], o, e);
    }
  }

  var T = {
    isArray: y,
    isArrayBuffer: function isArrayBuffer(e) {
      return "[object ArrayBuffer]" === g.call(e);
    },
    isBuffer: function isBuffer(e) {
      return null !== e && !v(e) && null !== e.constructor && !v(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
    },
    isFormData: function isFormData(e) {
      return "undefined" != typeof FormData && e instanceof FormData;
    },
    isArrayBufferView: function isArrayBufferView(e) {
      return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer;
    },
    isString: function isString(e) {
      return "string" == typeof e;
    },
    isNumber: function isNumber(e) {
      return "number" == typeof e;
    },
    isObject: b,
    isPlainObject: E,
    isUndefined: v,
    isDate: function isDate(e) {
      return "[object Date]" === g.call(e);
    },
    isFile: function isFile(e) {
      return "[object File]" === g.call(e);
    },
    isBlob: function isBlob(e) {
      return "[object Blob]" === g.call(e);
    },
    isFunction: S,
    isStream: function isStream(e) {
      return b(e) && S(e.pipe);
    },
    isURLSearchParams: function isURLSearchParams(e) {
      return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams;
    },
    isStandardBrowserEnv: function isStandardBrowserEnv() {
      return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
    },
    forEach: w,
    merge: function e() {
      var t = {};

      function n(n, r) {
        E(t[r]) && E(n) ? t[r] = e(t[r], n) : E(n) ? t[r] = e({}, n) : y(n) ? t[r] = n.slice() : t[r] = n;
      }

      for (var r = 0, o = arguments.length; r < o; r++) {
        w(arguments[r], n);
      }

      return t;
    },
    extend: function extend(e, t, n) {
      return w(t, function (t, r) {
        e[r] = n && "function" == typeof t ? m(t, n) : t;
      }), e;
    },
    trim: function trim(e) {
      return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
    },
    stripBOM: function stripBOM(e) {
      return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e;
    }
  },
      A = T;

  function O(e) {
    return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }

  var P = function P(e, t, n) {
    if (!t) return e;
    var r;
    if (n) r = n(t);else if (A.isURLSearchParams(t)) r = t.toString();else {
      var o = [];
      A.forEach(t, function (e, t) {
        null != e && (A.isArray(e) ? t += "[]" : e = [e], A.forEach(e, function (e) {
          A.isDate(e) ? e = e.toISOString() : A.isObject(e) && (e = JSON.stringify(e)), o.push(O(t) + "=" + O(e));
        }));
      }), r = o.join("&");
    }

    if (r) {
      var i = e.indexOf("#");
      -1 !== i && (e = e.slice(0, i)), e += (-1 === e.indexOf("?") ? "?" : "&") + r;
    }

    return e;
  },
      x = T;

  function R() {
    this.handlers = [];
  }

  R.prototype.use = function (e, t, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: !!n && n.synchronous,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }, R.prototype.eject = function (e) {
    this.handlers[e] && (this.handlers[e] = null);
  }, R.prototype.forEach = function (e) {
    x.forEach(this.handlers, function (t) {
      null !== t && e(t);
    });
  };

  var j = R,
      I = T,
      N = function N(e, t, n, r, o) {
    return e.config = t, n && (e.code = n), e.request = r, e.response = o, e.isAxiosError = !0, e.toJSON = function () {
      return {
        message: this.message,
        name: this.name,
        description: this.description,
        number: this.number,
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        config: this.config,
        code: this.code,
        status: this.response && this.response.status ? this.response.status : null
      };
    }, e;
  },
      C = N,
      D = function D(e, t, n, r, o) {
    var i = new Error(e);
    return C(i, t, n, r, o);
  },
      L = D,
      U = T,
      M = U.isStandardBrowserEnv() ? {
    write: function write(e, t, n, r, o, i) {
      var a = [];
      a.push(e + "=" + encodeURIComponent(t)), U.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), U.isString(r) && a.push("path=" + r), U.isString(o) && a.push("domain=" + o), !0 === i && a.push("secure"), document.cookie = a.join("; ");
    },
    read: function read(e) {
      var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove: function remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  } : {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  },
      q = function q(e) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
  },
      _ = function _(e, t) {
    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
  },
      B = T,
      k = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"],
      F = T,
      V = F.isStandardBrowserEnv() ? function () {
    var e,
        t = /(msie|trident)/i.test(navigator.userAgent),
        n = document.createElement("a");

    function r(e) {
      var r = e;
      return t && (n.setAttribute("href", r), r = n.href), n.setAttribute("href", r), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
      };
    }

    return e = r(window.location.href), function (t) {
      var n = F.isString(t) ? r(t) : t;
      return n.protocol === e.protocol && n.host === e.host;
    };
  }() : function () {
    return !0;
  };

  function $(e) {
    this.message = e;
  }

  $.prototype.toString = function () {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, $.prototype.__CANCEL__ = !0;

  var J = $,
      H = T,
      z = function z(e, t, n) {
    var r = n.config.validateStatus;
    n.status && r && !r(n.status) ? t(L("Request failed with status code " + n.status, n.config, null, n.request, n)) : e(n);
  },
      G = M,
      X = P,
      W = function W(e, t) {
    return e && !q(t) ? _(e, t) : t;
  },
      Y = function Y(e) {
    var t,
        n,
        r,
        o = {};
    return e ? (B.forEach(e.split("\n"), function (e) {
      if (r = e.indexOf(":"), t = B.trim(e.substr(0, r)).toLowerCase(), n = B.trim(e.substr(r + 1)), t) {
        if (o[t] && k.indexOf(t) >= 0) return;
        o[t] = "set-cookie" === t ? (o[t] ? o[t] : []).concat([n]) : o[t] ? o[t] + ", " + n : n;
      }
    }), o) : o;
  },
      K = V,
      Z = D,
      Q = ue,
      ee = J,
      te = function te(e) {
    return new Promise(function (t, n) {
      var r,
          o = e.data,
          i = e.headers,
          a = e.responseType;

      function s() {
        e.cancelToken && e.cancelToken.unsubscribe(r), e.signal && e.signal.removeEventListener("abort", r);
      }

      H.isFormData(o) && delete i["Content-Type"];
      var c = new XMLHttpRequest();

      if (e.auth) {
        var u = e.auth.username || "",
            f = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
        i.Authorization = "Basic " + btoa(u + ":" + f);
      }

      var l = W(e.baseURL, e.url);

      function d() {
        if (c) {
          var r = "getAllResponseHeaders" in c ? Y(c.getAllResponseHeaders()) : null,
              o = {
            data: a && "text" !== a && "json" !== a ? c.response : c.responseText,
            status: c.status,
            statusText: c.statusText,
            headers: r,
            config: e,
            request: c
          };
          z(function (e) {
            t(e), s();
          }, function (e) {
            n(e), s();
          }, o), c = null;
        }
      }

      if (c.open(e.method.toUpperCase(), X(l, e.params, e.paramsSerializer), !0), c.timeout = e.timeout, "onloadend" in c ? c.onloadend = d : c.onreadystatechange = function () {
        c && 4 === c.readyState && (0 !== c.status || c.responseURL && 0 === c.responseURL.indexOf("file:")) && setTimeout(d);
      }, c.onabort = function () {
        c && (n(Z("Request aborted", e, "ECONNABORTED", c)), c = null);
      }, c.onerror = function () {
        n(Z("Network Error", e, null, c)), c = null;
      }, c.ontimeout = function () {
        var t = "timeout of " + e.timeout + "ms exceeded",
            r = e.transitional || Q.transitional;
        e.timeoutErrorMessage && (t = e.timeoutErrorMessage), n(Z(t, e, r.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", c)), c = null;
      }, H.isStandardBrowserEnv()) {
        var p = (e.withCredentials || K(l)) && e.xsrfCookieName ? G.read(e.xsrfCookieName) : void 0;
        p && (i[e.xsrfHeaderName] = p);
      }

      "setRequestHeader" in c && H.forEach(i, function (e, t) {
        void 0 === o && "content-type" === t.toLowerCase() ? delete i[t] : c.setRequestHeader(t, e);
      }), H.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), a && "json" !== a && (c.responseType = e.responseType), "function" == typeof e.onDownloadProgress && c.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && c.upload && c.upload.addEventListener("progress", e.onUploadProgress), (e.cancelToken || e.signal) && (r = function r(e) {
        c && (n(!e || e && e.type ? new ee("canceled") : e), c.abort(), c = null);
      }, e.cancelToken && e.cancelToken.subscribe(r), e.signal && (e.signal.aborted ? r() : e.signal.addEventListener("abort", r))), o || (o = null), c.send(o);
    });
  },
      ne = T,
      re = function re(e, t) {
    I.forEach(e, function (n, r) {
      r !== t && r.toUpperCase() === t.toUpperCase() && (e[t] = n, delete e[r]);
    });
  },
      oe = N,
      ie = {
    "Content-Type": "application/x-www-form-urlencoded"
  };

  function ae(e, t) {
    !ne.isUndefined(e) && ne.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
  }

  var se,
      ce = {
    transitional: {
      silentJSONParsing: !0,
      forcedJSONParsing: !0,
      clarifyTimeoutError: !1
    },
    adapter: (("undefined" != typeof XMLHttpRequest || "undefined" != typeof process && "[object process]" === Object.prototype.toString.call(process)) && (se = te), se),
    transformRequest: [function (e, t) {
      return re(t, "Accept"), re(t, "Content-Type"), ne.isFormData(e) || ne.isArrayBuffer(e) || ne.isBuffer(e) || ne.isStream(e) || ne.isFile(e) || ne.isBlob(e) ? e : ne.isArrayBufferView(e) ? e.buffer : ne.isURLSearchParams(e) ? (ae(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : ne.isObject(e) || t && "application/json" === t["Content-Type"] ? (ae(t, "application/json"), function (e, t, n) {
        if (ne.isString(e)) try {
          return (t || JSON.parse)(e), ne.trim(e);
        } catch (e) {
          if ("SyntaxError" !== e.name) throw e;
        }
        return (n || JSON.stringify)(e);
      }(e)) : e;
    }],
    transformResponse: [function (e) {
      var t = this.transitional || ce.transitional,
          n = t && t.silentJSONParsing,
          r = t && t.forcedJSONParsing,
          o = !n && "json" === this.responseType;
      if (o || r && ne.isString(e) && e.length) try {
        return JSON.parse(e);
      } catch (e) {
        if (o) {
          if ("SyntaxError" === e.name) throw oe(e, this, "E_JSON_PARSE");
          throw e;
        }
      }
      return e;
    }],
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(e) {
      return e >= 200 && e < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }
  };
  ne.forEach(["delete", "get", "head"], function (e) {
    ce.headers[e] = {};
  }), ne.forEach(["post", "put", "patch"], function (e) {
    ce.headers[e] = ne.merge(ie);
  });

  var ue = ce,
      fe = T,
      le = ue,
      de = function de(e) {
    return !(!e || !e.__CANCEL__);
  },
      pe = T,
      he = function he(e, t, n) {
    var r = this || le;
    return fe.forEach(n, function (n) {
      e = n.call(r, e, t);
    }), e;
  },
      me = de,
      ge = ue,
      ye = J;

  function ve(e) {
    if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new ye("canceled");
  }

  var be = T,
      Ee = function Ee(e, t) {
    t = t || {};
    var n = {};

    function r(e, t) {
      return be.isPlainObject(e) && be.isPlainObject(t) ? be.merge(e, t) : be.isPlainObject(t) ? be.merge({}, t) : be.isArray(t) ? t.slice() : t;
    }

    function o(n) {
      return be.isUndefined(t[n]) ? be.isUndefined(e[n]) ? void 0 : r(void 0, e[n]) : r(e[n], t[n]);
    }

    function i(e) {
      if (!be.isUndefined(t[e])) return r(void 0, t[e]);
    }

    function a(n) {
      return be.isUndefined(t[n]) ? be.isUndefined(e[n]) ? void 0 : r(void 0, e[n]) : r(void 0, t[n]);
    }

    function s(n) {
      return n in t ? r(e[n], t[n]) : n in e ? r(void 0, e[n]) : void 0;
    }

    var c = {
      url: i,
      method: i,
      data: i,
      baseURL: a,
      transformRequest: a,
      transformResponse: a,
      paramsSerializer: a,
      timeout: a,
      timeoutMessage: a,
      withCredentials: a,
      adapter: a,
      responseType: a,
      xsrfCookieName: a,
      xsrfHeaderName: a,
      onUploadProgress: a,
      onDownloadProgress: a,
      decompress: a,
      maxContentLength: a,
      maxBodyLength: a,
      transport: a,
      httpAgent: a,
      httpsAgent: a,
      cancelToken: a,
      socketPath: a,
      responseEncoding: a,
      validateStatus: s
    };
    return be.forEach(Object.keys(e).concat(Object.keys(t)), function (e) {
      var t = c[e] || o,
          r = t(e);
      be.isUndefined(r) && t !== s || (n[e] = r);
    }), n;
  },
      Se = "0.22.0",
      we = Se,
      Te = {};

  ["object", "boolean", "number", "function", "string", "symbol"].forEach(function (e, t) {
    Te[e] = function (n) {
      return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
    };
  });
  var Ae = {};

  Te.transitional = function (e, t, n) {
    function r(e, t) {
      return "[Axios v" + we + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
    }

    return function (n, o, i) {
      if (!1 === e) throw new Error(r(o, " has been removed" + (t ? " in " + t : "")));
      return t && !Ae[o] && (Ae[o] = !0, console.warn(r(o, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, o, i);
    };
  };

  var Oe = T,
      Pe = P,
      xe = j,
      Re = function Re(e) {
    return ve(e), e.headers = e.headers || {}, e.data = he.call(e, e.data, e.headers, e.transformRequest), e.headers = pe.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), pe.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
      delete e.headers[t];
    }), (e.adapter || ge.adapter)(e).then(function (t) {
      return ve(e), t.data = he.call(e, t.data, t.headers, e.transformResponse), t;
    }, function (t) {
      return me(t) || (ve(e), t && t.response && (t.response.data = he.call(e, t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t);
    });
  },
      je = Ee,
      Ie = {
    assertOptions: function assertOptions(e, t, n) {
      if ("object" != typeof e) throw new TypeError("options must be an object");

      for (var r = Object.keys(e), o = r.length; o-- > 0;) {
        var i = r[o],
            a = t[i];

        if (a) {
          var s = e[i],
              c = void 0 === s || a(s, i, e);
          if (!0 !== c) throw new TypeError("option " + i + " must be " + c);
        } else if (!0 !== n) throw Error("Unknown option " + i);
      }
    },
    validators: Te
  },
      Ne = Ie.validators;

  function Ce(e) {
    this.defaults = e, this.interceptors = {
      request: new xe(),
      response: new xe()
    };
  }

  Ce.prototype.request = function (e) {
    "string" == typeof e ? (e = arguments[1] || {}).url = arguments[0] : e = e || {}, (e = je(this.defaults, e)).method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
    var t = e.transitional;
    void 0 !== t && Ie.assertOptions(t, {
      silentJSONParsing: Ne.transitional(Ne.boolean),
      forcedJSONParsing: Ne.transitional(Ne.boolean),
      clarifyTimeoutError: Ne.transitional(Ne.boolean)
    }, !1);
    var n = [],
        r = !0;
    this.interceptors.request.forEach(function (t) {
      "function" == typeof t.runWhen && !1 === t.runWhen(e) || (r = r && t.synchronous, n.unshift(t.fulfilled, t.rejected));
    });
    var o,
        i = [];

    if (this.interceptors.response.forEach(function (e) {
      i.push(e.fulfilled, e.rejected);
    }), !r) {
      var a = [Re, void 0];

      for (Array.prototype.unshift.apply(a, n), a = a.concat(i), o = Promise.resolve(e); a.length;) {
        o = o.then(a.shift(), a.shift());
      }

      return o;
    }

    for (var s = e; n.length;) {
      var c = n.shift(),
          u = n.shift();

      try {
        s = c(s);
      } catch (e) {
        u(e);
        break;
      }
    }

    try {
      o = Re(s);
    } catch (e) {
      return Promise.reject(e);
    }

    for (; i.length;) {
      o = o.then(i.shift(), i.shift());
    }

    return o;
  }, Ce.prototype.getUri = function (e) {
    return e = je(this.defaults, e), Pe(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
  }, Oe.forEach(["delete", "get", "head", "options"], function (e) {
    Ce.prototype[e] = function (t, n) {
      return this.request(je(n || {}, {
        method: e,
        url: t,
        data: (n || {}).data
      }));
    };
  }), Oe.forEach(["post", "put", "patch"], function (e) {
    Ce.prototype[e] = function (t, n, r) {
      return this.request(je(r || {}, {
        method: e,
        url: t,
        data: n
      }));
    };
  });
  var De = Ce,
      Le = J;

  function Ue(e) {
    if ("function" != typeof e) throw new TypeError("executor must be a function.");
    var t;
    this.promise = new Promise(function (e) {
      t = e;
    });
    var n = this;
    this.promise.then(function (e) {
      if (n._listeners) {
        var t,
            r = n._listeners.length;

        for (t = 0; t < r; t++) {
          n._listeners[t](e);
        }

        n._listeners = null;
      }
    }), this.promise.then = function (e) {
      var t,
          r = new Promise(function (e) {
        n.subscribe(e), t = e;
      }).then(e);
      return r.cancel = function () {
        n.unsubscribe(t);
      }, r;
    }, e(function (e) {
      n.reason || (n.reason = new Le(e), t(n.reason));
    });
  }

  Ue.prototype.throwIfRequested = function () {
    if (this.reason) throw this.reason;
  }, Ue.prototype.subscribe = function (e) {
    this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }, Ue.prototype.unsubscribe = function (e) {
    if (this._listeners) {
      var t = this._listeners.indexOf(e);

      -1 !== t && this._listeners.splice(t, 1);
    }
  }, Ue.source = function () {
    var e;
    return {
      token: new Ue(function (t) {
        e = t;
      }),
      cancel: e
    };
  };
  var Me = Ue,
      qe = T,
      _e = h,
      Be = De,
      ke = Ee;

  var Fe = function e(t) {
    var n = new Be(t),
        r = _e(Be.prototype.request, n);

    return qe.extend(r, Be.prototype, n), qe.extend(r, n), r.create = function (n) {
      return e(ke(t, n));
    }, r;
  }(ue);

  Fe.Axios = Be, Fe.Cancel = J, Fe.CancelToken = Me, Fe.isCancel = de, Fe.VERSION = Se, Fe.all = function (e) {
    return Promise.all(e);
  }, Fe.spread = function (e) {
    return function (t) {
      return e.apply(null, t);
    };
  }, Fe.isAxiosError = function (e) {
    return "object" == typeof e && !0 === e.isAxiosError;
  }, p.exports = Fe, p.exports.default = Fe;
  var Ve,
      $e = p.exports,
      Je = new Uint8Array(16);

  function He() {
    if (!Ve && !(Ve = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return Ve(Je);
  }

  var ze = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

  function Ge(e) {
    return "string" == typeof e && ze.test(e);
  }

  for (var Xe = [], We = 0; We < 256; ++We) {
    Xe.push((We + 256).toString(16).substr(1));
  }

  function Ye(e, t, n) {
    var r = (e = e || {}).random || (e.rng || He)();

    if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
      n = n || 0;

      for (var o = 0; o < 16; ++o) {
        t[n + o] = r[o];
      }

      return t;
    }

    return function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = (Xe[e[t + 0]] + Xe[e[t + 1]] + Xe[e[t + 2]] + Xe[e[t + 3]] + "-" + Xe[e[t + 4]] + Xe[e[t + 5]] + "-" + Xe[e[t + 6]] + Xe[e[t + 7]] + "-" + Xe[e[t + 8]] + Xe[e[t + 9]] + "-" + Xe[e[t + 10]] + Xe[e[t + 11]] + Xe[e[t + 12]] + Xe[e[t + 13]] + Xe[e[t + 14]] + Xe[e[t + 15]]).toLowerCase();
      if (!Ge(n)) throw TypeError("Stringified UUID is invalid");
      return n;
    }(r);
  }

  function Ke(e) {
    return isNaN(Number(e)) ? e : {
      scaled: Number(e)
    };
  }

  var Ze = /*#__PURE__*/function () {
    function Ze() {
      _classCallCheck(this, Ze);

      if (this.launchParameters = this.getLaunchParametersFromLMS(), !this.launchParameters.fetch) throw Error("Unable to construct, no `fetch` parameter found in URL.");
      if (!this.launchParameters.endpoint) throw Error("Unable to construct, no `endpoint` parameter found in URL");
      if (!this.launchParameters.actor) throw Error("Unable to construct, no `actor` parameter found in URL.");
      if (!this.launchParameters.activityId) throw Error("Unable to construct, no `activityId` parameter found in URL.");
      if (!this.launchParameters.registration) throw Error("Unable to construct, no `registration` parameter found in URL.");
    }

    _createClass(Ze, [{
      key: "isAuthenticated",
      get: function get() {
        return Boolean(Ze._xapi);
      }
    }, {
      key: "getLaunchParameters",
      value: function getLaunchParameters() {
        return this.launchParameters;
      }
    }, {
      key: "getLaunchData",
      value: function getLaunchData() {
        return this.launchData;
      }
    }, {
      key: "getLearnerPreferences",
      value: function getLearnerPreferences() {
        return this.learnerPreferences;
      }
    }, {
      key: "initialize",
      value: function initialize() {
        var _this = this;

        return this.getAuthTokenFromLMS(this.launchParameters.fetch).then(function (e) {
          var n = e.data["auth-token"];
          return Ze._xapi = new t(_this.launchParameters.endpoint, "Basic " + n), _this.getLaunchDataFromLMS();
        }).then(function (e) {
          _this.launchData = e.data;
        }).then(function () {
          return _this.getLearnerPreferencesFromLMS();
        }).then(function (e) {
          _this.learnerPreferences = e.data || {};
        }).then(function () {
          return _this.initialisedDate = new Date(), _this.sendCmi5DefinedStatement({
            verb: r.INITIALIZED
          });
        });
      }
    }, {
      key: "complete",
      value: function complete(e) {
        return "Normal" !== this.launchData.launchMode ? Promise.reject(new Error("Can only send COMPLETED when launchMode is 'Normal'")) : this.sendCmi5DefinedStatement({
          verb: r.COMPLETED,
          result: {
            completion: !0,
            duration: t.calculateISO8601Duration(this.initialisedDate, new Date())
          },
          context: {
            contextActivities: {
              category: [n.MOVE_ON]
            }
          }
        }, e);
      }
    }, {
      key: "pass",
      value: function pass(e, o) {
        if ("Normal" !== this.launchData.launchMode) return Promise.reject(new Error("Can only send PASSED when launchMode is 'Normal'"));
        var i = Ke(e);
        if (this.launchData.masteryScore && (!i || isNaN(Number(i.scaled)) || i.scaled < this.launchData.masteryScore)) return Promise.reject(new Error("Learner has not met Mastery Score"));

        var _ref = (c = o) && "Activity" === c.objectType && "string" == typeof c.id && c.definition && "object" == typeof c.definition && "http://adlnet.gov/expapi/activities/objective" === c.definition.type ? [o, void 0] : [o ? o.objectiveActivity : void 0, o],
            _ref2 = _slicedToArray(_ref, 2),
            a = _ref2[0],
            s = _ref2[1];

        var c;
        return this.sendCmi5DefinedStatement({
          verb: r.PASSED,
          result: _objectSpread(_objectSpread({}, i ? {
            score: i
          } : {}), {}, {
            success: !0,
            duration: t.calculateISO8601Duration(this.initialisedDate, new Date())
          }),
          context: _objectSpread({
            contextActivities: _objectSpread({
              category: [n.MOVE_ON]
            }, a ? {
              parent: [a]
            } : {})
          }, this.launchData.masteryScore ? {
            extensions: {
              "https://w3id.org/xapi/cmi5/context/extensions/masteryscore": this.launchData.masteryScore
            }
          } : {})
        }, s);
      }
    }, {
      key: "fail",
      value: function fail(e, o) {
        if ("Normal" !== this.launchData.launchMode) return Promise.reject(new Error("Can only send FAILED when launchMode is 'Normal'"));
        var i = Ke(e);
        return this.sendCmi5DefinedStatement({
          verb: r.FAILED,
          result: _objectSpread(_objectSpread({}, i ? {
            score: i
          } : {}), {}, {
            success: !1,
            duration: t.calculateISO8601Duration(this.initialisedDate, new Date())
          }),
          context: _objectSpread({
            contextActivities: {
              category: [n.MOVE_ON]
            }
          }, this.launchData.masteryScore ? {
            extensions: {
              "https://w3id.org/xapi/cmi5/context/extensions/masteryscore": this.launchData.masteryScore
            }
          } : {})
        }, o);
      }
    }, {
      key: "terminate",
      value: function terminate() {
        return this.sendCmi5DefinedStatement({
          verb: r.TERMINATED,
          result: {
            duration: t.calculateISO8601Duration(this.initialisedDate, new Date())
          }
        });
      }
    }, {
      key: "progress",
      value: function progress(e) {
        return this.sendCmi5AllowedStatement({
          verb: t.Verbs.PROGRESSED,
          object: {
            objectType: "Activity",
            id: this.launchParameters.activityId
          },
          result: {
            extensions: {
              "https://w3id.org/xapi/cmi5/result/extensions/progress": e
            }
          }
        });
      }
    }, {
      key: "interactionTrueFalse",
      value: function interactionTrueFalse(e, t, n, r, o, i, a, s, c) {
        return this.interaction(e, t, n.toString(), _objectSpread(_objectSpread(_objectSpread({
          type: "http://adlnet.gov/expapi/activities/cmi.interaction",
          interactionType: "true-false"
        }, void 0 !== r ? {
          correctResponsesPattern: r ? ["true"] : ["false"]
        } : {}), o ? {
          name: o
        } : {}), i ? {
          description: i
        } : {}), a, s, c);
      }
    }, {
      key: "interactionChoice",
      value: function interactionChoice(e, t, n, r, o, i, a, s, c, u) {
        return this.interaction(e, t, n.join("[,]"), _objectSpread(_objectSpread(_objectSpread(_objectSpread({
          type: "http://adlnet.gov/expapi/activities/cmi.interaction",
          interactionType: "choice"
        }, r ? {
          correctResponsesPattern: [r.join("[,]")]
        } : {}), o ? {
          choices: o
        } : {}), i ? {
          name: i
        } : {}), a ? {
          description: a
        } : {}), s, c, u);
      }
    }, {
      key: "interactionFillIn",
      value: function interactionFillIn(e, t, n, r, o, i, a, s, c) {
        return this.interaction(e, t, n.join("[,]"), _objectSpread(_objectSpread(_objectSpread({
          type: "http://adlnet.gov/expapi/activities/cmi.interaction",
          interactionType: "fill-in"
        }, r ? {
          correctResponsesPattern: [r.join("[,]")]
        } : {}), o ? {
          name: o
        } : {}), i ? {
          description: i
        } : {}), a, s, c);
      }
    }, {
      key: "interactionLongFillIn",
      value: function interactionLongFillIn(e, t, n, r, o, i, a, s, c) {
        return this.interaction(e, t, n.join("[,]"), _objectSpread(_objectSpread(_objectSpread({
          type: "http://adlnet.gov/expapi/activities/cmi.interaction",
          interactionType: "long-fill-in"
        }, r ? {
          correctResponsesPattern: [r.join("[,]")]
        } : {}), o ? {
          name: o
        } : {}), i ? {
          description: i
        } : {}), a, s, c);
      }
    }, {
      key: "interactionLikert",
      value: function interactionLikert(e, t, n, r, o, i, a, s, c, u) {
        return this.interaction(e, t, n, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
          type: "http://adlnet.gov/expapi/activities/cmi.interaction",
          interactionType: "likert"
        }, r ? {
          correctResponsesPattern: [r]
        } : {}), o ? {
          scale: o
        } : {}), i ? {
          name: i
        } : {}), a ? {
          description: a
        } : {}), s, c, u);
      }
    }, {
      key: "interactionMatching",
      value: function interactionMatching(e, t, n, r, o, i, a, s, c, u, f) {
        return this.interaction(e, t, Object.keys(n).map(function (e) {
          return "".concat(e, "[.]").concat(n[e]);
        }).join("[,]"), _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          type: "http://adlnet.gov/expapi/activities/cmi.interaction",
          interactionType: "matching"
        }, r ? {
          correctResponsesPattern: [Object.keys(r).map(function (e) {
            return "".concat(e, "[.]").concat(r[e]);
          }).join("[,]")]
        } : {}), o ? {
          source: o
        } : {}), i ? {
          target: i
        } : {}), a ? {
          name: a
        } : {}), s ? {
          description: s
        } : {}), c, u, f);
      }
    }, {
      key: "interactionPerformance",
      value: function interactionPerformance(e, t, n, r, o, i, a, s, c, u) {
        return this.interaction(e, t, Object.keys(n).map(function (e) {
          return "".concat(e, "[.]").concat(n[e]);
        }).join("[,]"), _objectSpread(_objectSpread(_objectSpread(_objectSpread({
          type: "http://adlnet.gov/expapi/activities/cmi.interaction",
          interactionType: "performance"
        }, r ? {
          correctResponsesPattern: [Object.keys(r).map(function (e) {
            var t = r[e].exact ? r[e].exact.toString() : "",
                n = r[e].min ? r[e].min.toString() : "",
                o = r[e].max ? r[e].max.toString() : "";
            return "".concat(e, "[.]").concat(t || n + ":" + o);
          }).join("[,]")]
        } : {}), o ? {
          steps: o
        } : {}), i ? {
          name: i
        } : {}), a ? {
          description: a
        } : {}), s, c, u);
      }
    }, {
      key: "interactionSequencing",
      value: function interactionSequencing(e, t, n, r, o, i, a, s, c, u) {
        return this.interaction(e, t, n.join("[,]"), _objectSpread(_objectSpread(_objectSpread(_objectSpread({
          type: "http://adlnet.gov/expapi/activities/cmi.interaction",
          interactionType: "sequencing"
        }, r ? {
          correctResponsesPattern: [r.join("[,]")]
        } : {}), o ? {
          choices: o
        } : {}), i ? {
          name: i
        } : {}), a ? {
          description: a
        } : {}), s, c, u);
      }
    }, {
      key: "interactionNumeric",
      value: function interactionNumeric(e, t, n, r, o, i, a, s, c) {
        return this.interaction(e, t, n.toString(), _objectSpread(_objectSpread(_objectSpread({
          type: "http://adlnet.gov/expapi/activities/cmi.interaction",
          interactionType: "numeric"
        }, r ? {
          correctResponsesPattern: ["" + (r.exact ? r.exact : r.min + ":" + r.max)]
        } : {}), o ? {
          name: o
        } : {}), i ? {
          description: i
        } : {}), a, s, c);
      }
    }, {
      key: "interactionOther",
      value: function interactionOther(e, t, n, r, o, i, a, s, c) {
        return this.interaction(e, t, n, _objectSpread(_objectSpread(_objectSpread({
          type: "http://adlnet.gov/expapi/activities/cmi.interaction",
          interactionType: "other"
        }, r ? {
          correctResponsesPattern: [r]
        } : {}), o ? {
          name: o
        } : {}), i ? {
          description: i
        } : {}), a, s, c);
      }
    }, {
      key: "interaction",
      value: function interaction(e, n, r, o, i, a, s) {
        return this.sendCmi5AllowedStatement(_objectSpread({
          verb: t.Verbs.ANSWERED,
          result: _objectSpread(_objectSpread({
            response: r
          }, a ? {
            duration: t.calculateISO8601Duration(a.start, a.end)
          } : {}), "boolean" == typeof i ? {
            success: i
          } : {}),
          object: {
            objectType: "Activity",
            id: "".concat(this.launchParameters.activityId, "/test/").concat(e, "/question/").concat(n),
            definition: o
          }
        }, s ? {
          context: {
            contextActivities: {
              parent: [s]
            }
          }
        } : {}));
      }
    }, {
      key: "setResultScore",
      value: function setResultScore(e, t) {
        return _objectSpread(_objectSpread({}, t), {}, {
          result: _objectSpread(_objectSpread({}, t.result || {}), {}, {
            score: e
          })
        });
      }
    }, {
      key: "moveOn",
      value: function () {
        var _moveOn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
          var _this2 = this;

          var t, n, r, o, _e4, i, _t2, _r3;

          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  n = e;

                  if (!("Normal" !== this.launchData.launchMode)) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt("return", Promise.reject(new Error("Can only send FAILED when launchMode is 'Normal'")));

                case 3:
                  r = [];

                  if (!(null !== (t = n) && void 0 !== t && t.score)) {
                    _context.next = 26;
                    break;
                  }

                  _e4 = Ke(null === (o = n) || void 0 === o ? void 0 : o.score);

                  if (!this.launchData.masteryScore) {
                    _context.next = 24;
                    break;
                  }

                  if (!(_e4.scaled >= this.launchData.masteryScore)) {
                    _context.next = 16;
                    break;
                  }

                  _context.t0 = this;
                  _context.next = 11;
                  return this.pass(_e4, n);

                case 11:
                  _context.t1 = _context.sent;
                  _context.t2 = r;

                  _context.t0.appendStatementIds.call(_context.t0, _context.t1, _context.t2);

                  _context.next = 22;
                  break;

                case 16:
                  _context.t3 = this;
                  _context.next = 19;
                  return this.fail(_e4, n);

                case 19:
                  _context.t4 = _context.sent;
                  _context.t5 = r;

                  _context.t3.appendStatementIds.call(_context.t3, _context.t4, _context.t5);

                case 22:
                  _context.next = 26;
                  break;

                case 24:
                  _t2 = function _t2(t) {
                    return _this2.setResultScore(_e4, t);
                  }, _r3 = null === (i = n) || void 0 === i ? void 0 : i.transform;
                  n = _objectSpread(_objectSpread({}, n || {}), {}, {
                    transform: "function" == typeof _r3 ? function (e) {
                      return _r3(_t2(e));
                    } : function (e) {
                      return _t2(e);
                    }
                  });

                case 26:
                  _context.t6 = this;
                  _context.next = 29;
                  return this.complete(n);

                case 29:
                  _context.t7 = _context.sent;
                  _context.t8 = r;

                  _context.t6.appendStatementIds.call(_context.t6, _context.t7, _context.t8);

                  _context.t9 = null != e && e.disableSendTerminated;

                  if (_context.t9) {
                    _context.next = 40;
                    break;
                  }

                  _context.t10 = this;
                  _context.next = 37;
                  return this.terminate();

                case 37:
                  _context.t11 = _context.sent;
                  _context.t12 = r;

                  _context.t10.appendStatementIds.call(_context.t10, _context.t11, _context.t12);

                case 40:
                  return _context.abrupt("return", r);

                case 41:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function moveOn(_x) {
          return _moveOn.apply(this, arguments);
        }

        return moveOn;
      }()
    }, {
      key: "appendStatementIds",
      value: function appendStatementIds(e, t) {
        t.push.apply(t, e.data);
      }
    }, {
      key: "getLaunchParametersFromLMS",
      value: function getLaunchParametersFromLMS() {
        return t.getSearchQueryParamsAsObject(window.location.href);
      }
    }, {
      key: "getAuthTokenFromLMS",
      value: function getAuthTokenFromLMS(e) {
        return $e.post(e);
      }
    }, {
      key: "getLaunchDataFromLMS",
      value: function getLaunchDataFromLMS() {
        return Ze._xapi.getState(this.launchParameters.actor, this.launchParameters.activityId, "LMS.LaunchData", this.launchParameters.registration);
      }
    }, {
      key: "getLearnerPreferencesFromLMS",
      value: function getLearnerPreferencesFromLMS() {
        return Ze._xapi.getAgentProfile(this.launchParameters.actor, "cmi5LearnerPreferences").then(function (e) {
          return e.data;
        }, function () {
          return {};
        });
      }
    }, {
      key: "sendCmi5DefinedStatement",
      value: function sendCmi5DefinedStatement(e, t) {
        var r = {
          object: {
            objectType: "Activity",
            id: this.launchParameters.activityId
          },
          context: {
            contextActivities: {
              category: [n.CMI5]
            }
          }
        },
            o = d.all([r, e]);
        return this.sendCmi5AllowedStatement(o, t);
      }
    }, {
      key: "sendCmi5AllowedStatement",
      value: function sendCmi5AllowedStatement(e, t) {
        var n = Ye(),
            r = this.launchParameters.actor,
            o = new Date().toISOString(),
            i = Object.assign({}, this.launchData.contextTemplate);
        i.registration = this.launchParameters.registration;
        var a = {
          id: n,
          actor: r,
          timestamp: o,
          context: i
        },
            s = d.all([a, e]),
            c = t && "function" == typeof t.transform ? t.transform(s) : s;
        return Ze._xapi.sendStatement(c);
      }
    }], [{
      key: "instance",
      get: function get() {
        return Ze._instance || (Ze._instance = new Ze()), Ze._instance;
      }
    }, {
      key: "clearInstance",
      value: function clearInstance() {
        Ze._instance = null;
      }
    }, {
      key: "xapi",
      get: function get() {
        return Ze._xapi;
      }
    }, {
      key: "isCmiAvailable",
      get: function get() {
        if (!window || "object" != typeof window) return !1;
        if (!window.location || "string" != typeof window.location.search) return !1;
        var e = new URLSearchParams(window.location.search);
        return Boolean(e.get("fetch") && e.get("endpoint") && e.get("actor") && e.get("registration") && e.get("activityId"));
      }
    }]);

    return Ze;
  }();

  return Ze._instance = null, Ze._xapi = null, Ze;
});